const BOM = '﻿';

export function downloadTextFile(text: string, filename: string, mime = 'text/plain'): void {
  const blob = new Blob([BOM + text], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
